import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSubstackComponent } from './simple-icons-substack.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSubstackComponent ],
    exports:      [ SimpleIconsSubstackComponent ],
    bootstrap:    []
})
export class SimpleIconsSubstackModule {}
